import styled from 'styled-components/macro';

export const Container = styled.div`
  border-top: 1px solid ${({ theme }) => theme.color.gray[90]};

  & > div {
    padding: 2rem;
  }
`;
